module.exports = __webpack_public_path__ + "static/xv-7ac37ec06067d71e44fa1c94919f9d1d.jpg";